import * as React from "react";
import { Filter, SelectInput } from 'react-admin';

const start = 2018
const thisYear = new Date().getFullYear()
const nextYear = thisYear + 1

const choises = new Array<{ id: number, name: string }>()

for (let y = start; y <= nextYear; y++) {
  choises.push({ id: y, name: `${y}` })
}

export const KintaiFilter = (props: {}) => {
  return <Filter {...props}>
    <SelectInput options={{ label: '年度' }} choices={choises} source="year" defaultValue={thisYear}></SelectInput>
  </Filter>
}